/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type UrnType = "Date" | "Email" | "Event" | "FlowState" | "Guest" | "Org" | "Phone" | "Services" | "Setting" | "Team" | "Teammate" | "TimeZone" | "User" | "WorkOsOrg" | "WorkingGroup" | "WorkingHours" | "%future added value";
export type RemoveGoalMutationInput = {
    clientMutationId?: string | null | undefined;
    goal: GoalInput;
    orgId: string;
};
export type GoalInput = {
    goalId: string;
    id: string;
    isDeleted: boolean;
    name: string;
    options?: GoalOptionsInput | null | undefined;
    otherUrns: Array<UrnInput>;
    targetUrn: UrnInput;
    valueUrn: UrnInput;
};
export type GoalOptionsInput = {
    syncToGoogle: boolean;
};
export type UrnInput = {
    id: string;
    scope?: UrnInput | null | undefined;
    type?: UrnType | null | undefined;
    value?: string | null | undefined;
};
export type RemoveGoalMutationVariables = {
    input: RemoveGoalMutationInput;
};
export type RemoveGoalMutationResponse = {
    readonly removeGoal: {
        readonly goal: {
            readonly id: string;
            readonly goalId: string;
            readonly targetUrn: {
                readonly id: string;
                readonly type: UrnType | null;
                readonly value: string | null;
            };
            readonly otherUrns: ReadonlyArray<{
                readonly id: string;
                readonly type: UrnType | null;
                readonly value: string | null;
            }>;
            readonly name: string;
            readonly valueUrn: {
                readonly id: string;
                readonly type: UrnType | null;
                readonly value: string | null;
            };
            readonly isDeleted: boolean;
            readonly options: {
                readonly syncToGoogle: boolean;
            } | null;
        } | null;
    } | null;
};
export type RemoveGoalMutation = {
    readonly response: RemoveGoalMutationResponse;
    readonly variables: RemoveGoalMutationVariables;
};



/*
mutation RemoveGoalMutation(
  $input: RemoveGoalMutationInput!
) {
  removeGoal(input: $input) {
    goal {
      id
      goalId
      targetUrn {
        id
        type
        value
      }
      otherUrns {
        id
        type
        value
      }
      name
      valueUrn {
        id
        type
        value
      }
      isDeleted
      options {
        syncToGoogle
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any
    ], v1 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v2 = [
        (v1 /*: any*/),
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "value",
            "storageKey": null
        } as any
    ], v3 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "RemoveGoalMutationPayload",
            "kind": "LinkedField",
            "name": "removeGoal",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Goal",
                    "kind": "LinkedField",
                    "name": "goal",
                    "plural": false,
                    "selections": [
                        (v1 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "goalId",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Urn",
                            "kind": "LinkedField",
                            "name": "targetUrn",
                            "plural": false,
                            "selections": (v2 /*: any*/),
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Urn",
                            "kind": "LinkedField",
                            "name": "otherUrns",
                            "plural": true,
                            "selections": (v2 /*: any*/),
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Urn",
                            "kind": "LinkedField",
                            "name": "valueUrn",
                            "plural": false,
                            "selections": (v2 /*: any*/),
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isDeleted",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "GoalOptions",
                            "kind": "LinkedField",
                            "name": "options",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "syncToGoogle",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "RemoveGoalMutation",
            "selections": (v3 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "RemoveGoalMutation",
            "selections": (v3 /*: any*/)
        },
        "params": {
            "cacheID": "2a4571500539edac875bc279e839beee",
            "id": null,
            "metadata": {},
            "name": "RemoveGoalMutation",
            "operationKind": "mutation",
            "text": "mutation RemoveGoalMutation(\n  $input: RemoveGoalMutationInput!\n) {\n  removeGoal(input: $input) {\n    goal {\n      id\n      goalId\n      targetUrn {\n        id\n        type\n        value\n      }\n      otherUrns {\n        id\n        type\n        value\n      }\n      name\n      valueUrn {\n        id\n        type\n        value\n      }\n      isDeleted\n      options {\n        syncToGoogle\n      }\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '0c7f2eb3a1226d2edae26b4927bbf3b4';
export default node;
